import React from "react";

export default function ReferralIcon() {
  return (
    <svg
      width="17"
      height="19"
      viewBox="0 0 17 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.9045 12.8415C6.94821 12.8852 7.00388 12.915 7.06449 12.927C7.1251 12.9391 7.18793 12.9329 7.24502 12.9092C7.30211 12.8856 7.35092 12.8455 7.38525 12.7942C7.41959 12.7428 7.43793 12.6824 7.43794 12.6206V8.99995H8.06294C12.5501 8.99995 16.1879 13.5753 16.1879 18.0625V11.8125C16.1879 6.97995 12.2704 3.99995 7.43794 3.99995V0.379328C7.43793 0.317531 7.41959 0.257125 7.38525 0.205747C7.35092 0.154369 7.30211 0.114325 7.24502 0.0906786C7.18793 0.0670317 7.1251 0.0608433 7.06449 0.0728956C7.00388 0.084948 6.94821 0.1147 6.9045 0.15839L0.783878 6.27901C0.725294 6.33762 0.692383 6.41709 0.692383 6.49995C0.692383 6.58282 0.725294 6.66229 0.783878 6.72089L6.9045 12.8415Z"
        fill="white"
      />
    </svg>
  );
}
